<div class="d-flex flex-column gap-2 p-2 bottom-border">
  <div class="review-entry-label">{{ relationshipStatus?.typeId | relationshipStatusEffectiveDateLabel }}</div>
  <div class="d-flex gap-2 align-items-center">
    <div class="review-entry-value flex-grow-1">{{ relationshipStatus?.effectiveDate | date : 'MMMM d, y' }}</div>
    <img
      *ngIf="relationshipStatus?.typeId === RelationshipStatus.CommonLaw"
      class="tooltip-icon"
      [src]="'assets/icons/dark/CircleQuestion.svg'"
      [ngbTooltip]="tooltipText"
      alt=""
      height="20"
      width="20" />
  </div>
</div>
